import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    marginRight: theme.spacing(3),
    float: 'inherit',
  },
  syncLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '13px',
  },
  MuiGridContainer: {
    flexWrap: 'nowrap',
  },
}))
